// extracted by mini-css-extract-plugin
export default {"tabs":"tabs__-2ff5bf63","title":"title__-2ff5bf63","tab":"tab__-2ff5bf63","active":"active__-2ff5bf63"};